import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding: 20px 30px;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  width: 100%;
`;

export const FullLengthContainer = styled.div`
  padding-top: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const MessageContainer = styled.div`
  font-size: 14px;
  line-height: 16px;
  width: 100%;
  color: #00307e;
  padding: 15px 25px 0;
`;

export const Text = styled.span`
  padding-left: 10px;
`;
